import { render } from "./shares-table-form.vue?vue&type=template&id=48bf1762&scoped=true"
import script from "./shares-table-form.vue?vue&type=script&lang=ts"
export * from "./shares-table-form.vue?vue&type=script&lang=ts"

import "./shares-table-form.vue?vue&type=style&index=0&id=48bf1762&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48bf1762"

export default script